/*
  Black November lender (vl-bn): ponašanje za sections/vl-bn-hero.liquid i sections/vl-bn-paketi.liquid.

  Šta radi, po redu:
  1. Rok akcije: jedan izvor (data-vl-bn-end na heroju, ms od epohe, računato u Liquid-u u vremenskoj
     zoni prodavnice). Svi satovi (hero, sticky) čitaju odatle. Kad rok prođe: tajmeri se sakriju,
     html dobija data-vl-bn-ended, a CSS sakriva ponudu i poklone po paketu. Cene ostaju Rapi cene.
  2. Pločice = tabovi. Jedan panel (buy box) vidljiv, ostali hidden. Dubok link: #<ključ> ili ?paket=<ključ>
     (ključ = handle proizvoda bez "vila-"), pa svaki oglas može da sleti na svoj paket, a izbor ostaje.
  3. Rapi paketi: kao u vp-pdp-main-product — bundle se premešta u slot ako Rapi sleti negde drugde,
     izabrana traka dobija klasu vl-bn-selected (Rapi nema pouzdan marker), svaka traka dobija poklon
     po količini (data-gift-<količina> na panelu; količina iz window.rapi_bundle_<productId>.offers[i]).
     Ništa se ne premešta dok je pokazivač pritisnut (isti bag kao na PDP-u: klik "propadne").
  4. Dodaj u korpu: sopstveni submit preko /cart/add.js (product-form.js teme zavisi od starog headera).
     Količina se uzima iz izabrane Rapi trake tog panela, jer Rapi upisuje izabranu količinu u SVAKO
     polje quantity u dokumentu, pa bi drugi panel poslao tuđu količinu. Kupi odmah → /checkout.
     Fioka korpe se osvežava kroz Section Rendering API uz skidanje lazy-template omotača (cart-drawer.md).
  5. Akcija (kod): auto ili na klik, preko /discount/<kod> (kolačić), stanje u sessionStorage; posle potvrde
     cene na trakama padaju (procenat: bilo koja valuta; iznos: samo RSD). Ako auto-aktivacija ne uspe,
     prikaže se dugme. Na 127.0.0.1 /discount vraća 401 — akcija se testira na pravom domenu.
  6. Sticky traka (ispod 1024px): tajmer + dugme koje vodi do dugmadi aktivnog panela. Sakrivena dok su
     dugmad u ekranu i dok je otvorena fioka (body.freeze-scroll, CSS).
*/
(function () {
  'use strict';

  if (window.__vlBnLoaded) return;
  window.__vlBnLoaded = true;

  var doc = document;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function readStore(type, key) { try { return window[type].getItem(key); } catch (e) { return null; } }
  function writeStore(type, key, val) { try { window[type].setItem(key, val); } catch (e) { /* privatni režim */ } }
  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
  }

  var raf = typeof window.requestAnimationFrame === 'function'
    ? window.requestAnimationFrame.bind(window)
    : function (fn) { return window.setTimeout(fn, 16); };
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mobileQuery = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 1023px)') : null;

  var GIFT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4" y="10" width="16" height="10" rx="1"></rect><path d="M3 7h18v3H3zM12 7v13M12 7c-2-.2-4-1-4-2.7C8 2.6 11 2.6 12 5c1-2.4 4-2.4 4-.7 0 1.7-2 2.5-4 2.7z"></path></svg>';

  /* ------------------------------------------------------------ rok akcije */

  function deadline() {
    var el = $('[data-vl-bn-end]');
    var ms = el ? parseInt(el.getAttribute('data-vl-bn-end'), 10) : 0;
    return ms > 0 ? ms : 0;
  }

  /* -1 = rok nije zadat (ništa ne odbrojava, ponuda ne ističe) */
  function remaining() {
    var d = deadline();
    return d ? Math.max(0, Math.round((d - Date.now()) / 1000)) : -1;
  }

  function split(s) {
    return {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
  }

  var ended = false;
  var clocks = [];
  var clockTimer = null;

  /* "18d 04:22:10", bez dana kad ih nema — za crvenu traku, red u buy box-u i sticky traku */
  function compact(left) {
    var t = split(left);
    return (t.d ? t.d + 'd ' : '') + pad(t.h) + ':' + pad(t.m) + ':' + pad(t.s);
  }

  function markEnded() {
    if (ended) return;
    ended = true;
    doc.documentElement.setAttribute('data-vl-bn-ended', '');
    $$('[data-vl-bn-timer]').forEach(function (el) { setHidden(el, true); });
    $$('[data-vl-bn-ended-text]').forEach(function (el) { setHidden(el, false); });
    doc.dispatchEvent(new CustomEvent('vl-bn:ended'));
  }

  function tick() {
    var left = remaining();
    if (left === -1) return;
    if (left <= 0) markEnded();
    var text = compact(left);
    $$('[data-vl-bn-clock]').forEach(function (el) { if (el.textContent !== text) el.textContent = text; });
    clocks.forEach(function (fn) { try { fn(left); } catch (e) { /* jedan sat ne ruši ostale */ } });
  }

  /* bez roka (prazno end_at) nema ni odbrojavanja: traka, redovi i sticky sat se sklanjaju */
  function hideTimersWithoutDeadline(scope) {
    if (deadline()) return;
    $$('[data-vl-bn-timer]', scope).forEach(function (el) { setHidden(el, true); });
  }

  function startClock() {
    if (clockTimer) return;
    tick();
    clockTimer = window.setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ hero */

  function initHero(root) {
    if (!root || root.dataset.vlBnInit === 'true') return;
    root.dataset.vlBnInit = 'true';

    var values = {
      d: $('[data-vl-bn-t="d"]', root),
      h: $('[data-vl-bn-t="h"]', root),
      m: $('[data-vl-bn-t="m"]', root),
      s: $('[data-vl-bn-t="s"]', root)
    };

    clocks.push(function (left) {
      var t = split(left);
      if (values.d) values.d.textContent = pad(t.d);
      if (values.h) values.h.textContent = pad(t.h);
      if (values.m) values.m.textContent = pad(t.m);
      if (values.s) values.s.textContent = pad(t.s);
    });

    /*
      Pokloni: zatvorene kutije dok se ne kliknu. Klik → kratko drhtanje (is-opening), pa otvoreno
      stanje (is-open) sa nazivom i napomenom. Otvoreni pokloni se pamte do kraja sesije, da se
      posle povratka na stranu ne zatvaraju ponovo.
    */
    var GIFTS_KEY = 'vlBnGifts:' + (root.getAttribute('data-vl-bn-hero') || 'hero');
    var gifts = $$('[data-vl-bn-gift]', root);
    var opened = [];
    try { opened = JSON.parse(readStore('sessionStorage', GIFTS_KEY) || '[]'); } catch (e) { opened = []; }
    if (!Array.isArray(opened)) opened = [];

    function openGift(gift, animate) {
      if (gift.classList.contains('is-open')) return;
      var toggle = gift.querySelector('[data-vl-bn-gift-open]');
      var finish = function () {
        gift.classList.remove('is-opening');
        gift.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      };
      if (animate && !reduceMotion) {
        gift.classList.add('is-opening');
        window.setTimeout(finish, 420);
      } else {
        finish();
      }
      var index = gifts.indexOf(gift);
      if (index !== -1 && opened.indexOf(index) === -1) {
        opened.push(index);
        writeStore('sessionStorage', GIFTS_KEY, JSON.stringify(opened));
      }
    }

    gifts.forEach(function (gift, i) {
      if (opened.indexOf(i) !== -1) openGift(gift, false);
      on(gift.querySelector('[data-vl-bn-gift-open]'), 'click', function () { openGift(gift, true); });
    });

    /*
      Crvena traka je na desktopu fiksirana uz vrh (CSS), pa body dobija gornji razmak njene
      visine da ne prekrije hero. Na mobilnom je u toku strane. Posle isteka roka traka nestaje
      i razmak se skida.
    */
    var strip = root.parentNode ? root.parentNode.querySelector('[data-vl-bn-strip]') : null;
    if (strip) {
      var padBody = function () {
        var fixed = window.getComputedStyle(strip).position === 'fixed' && !strip.hasAttribute('hidden');
        doc.body.style.paddingTop = fixed ? strip.getBoundingClientRect().height + 'px' : '';
      };
      padBody();
      on(window, 'resize', padBody);
      on(doc, 'vl-bn:ended', padBody);
      on(window, 'load', padBody);
    }

    startClock();
  }

  /* ------------------------------------------------------------ cene (kao vp2-offer-600) */

  function parsePrice(text) {
    var m = String(text).match(/([\d.,]+)/);
    if (!m) return null;
    var s = m[1];
    if (/[.,]\d{2}$/.test(s)) {
      var dec = s.charAt(s.length - 3);
      var grp = dec === ',' ? '.' : ',';
      return { value: parseFloat(s.split(grp).join('').replace(dec, '.')), raw: m[1], decimals: 2, dec: dec, grp: grp };
    }
    return { value: parseInt(s.replace(/[.,]/g, ''), 10), raw: m[1], decimals: 0, dec: ',', grp: '.' };
  }

  function formatLike(parsed, value) {
    var fixed = value.toFixed(parsed.decimals);
    var parts = fixed.split('.');
    var ints = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, parsed.grp);
    return parsed.decimals ? ints + parsed.dec + parts[1] : ints;
  }

  /* ------------------------------------------------------------ fioka korpe (kao vp-pdp-main-product) */

  function unwrapLazyTemplates(markup) {
    if (window.lazyTemplateController && typeof window.lazyTemplateController.cleanHTMLWithTemplate === 'function') {
      return window.lazyTemplateController.cleanHTMLWithTemplate(markup);
    }
    return markup
      .replace(/<lazy-template[\s\S]*?<template>/g, '')
      .replace(/<\/template>[\s\S]*?<\/lazy-template>/g, '');
  }

  function hoistExternalResources(container) {
    if (window.scriptController && typeof window.scriptController.saveExternalResourcesFromContainer === 'function') {
      window.scriptController.saveExternalResourcesFromContainer(container);
    }
  }

  function refreshCartDrawer() {
    var drawer = doc.getElementById('cartDrawerSection');
    if (!drawer) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data['cart-drawer'];
        if (!markup) return;
        var parsed = new DOMParser().parseFromString(unwrapLazyTemplates(markup), 'text/html');
        var incoming = parsed.getElementById('cartDrawerSection');
        if (!incoming) return;
        hoistExternalResources(incoming);
        drawer.innerHTML = incoming.innerHTML;
      })
      .catch(function () { /* neuspelo osvežavanje ne sme da spreči otvaranje */ });
  }

  function openCartDrawer() {
    var drawer = doc.getElementById('cartDrawerSection');
    var modal = drawer ? drawer.querySelector('details-modal') : null;
    if (!modal || typeof modal.open !== 'function') {
      window.location.href = '/cart';
      return;
    }
    modal.open();
    drawer.classList.add('show-cart-drawer');
  }

  /* ------------------------------------------------------------ paketi */

  function initPaketi(root) {
    if (!root || root.dataset.vlBnInit === 'true') return;
    root.dataset.vlBnInit = 'true';

    var tabs = $$('[data-vl-bn-tab]', root);
    var panels = $$('[data-vl-bn-panel]', root);
    if (!tabs.length || !panels.length) return;

    var SELECTED = 'vl-bn-selected';
    var current = null;

    var offer = {
      code: root.getAttribute('data-offer-code') || '',
      type: root.getAttribute('data-offer-type') || 'none',
      value: parseFloat(root.getAttribute('data-offer-value')) || 0,
      mode: root.getAttribute('data-offer-mode') || 'auto',
      url: root.getAttribute('data-offer-url') || ''
    };
    var offerActive = !!(offer.code && offer.url && offer.type !== 'none' && offer.value > 0);
    var claimed = false;

    /* ---- pomoćne za panele ---- */

    function panelByKey(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-vl-bn-panel') === key) return panels[i];
      }
      return null;
    }

    function headerOffset() {
      var header = $('.header-sections-wrapper') || $('.shopify-section-group-header-group');
      if (!header) return 0;
      var pos = window.getComputedStyle(header).position;
      return pos === 'fixed' || pos === 'sticky' ? header.getBoundingClientRect().height : 0;
    }

    function scrollToEl(el, extra) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - (extra || 16);
      window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function keyFromUrl() {
      var hash = (window.location.hash || '').replace(/^#/, '');
      var m = window.location.search.match(/[?&]paket=([^&]+)/);
      var key = m ? decodeURIComponent(m[1]) : hash;
      return key && panelByKey(key) ? key : null;
    }

    function activate(key, opts) {
      opts = opts || {};
      var panel = panelByKey(key);
      if (!panel) return;

      panels.forEach(function (p) { setHidden(p, p !== panel); });
      tabs.forEach(function (t) {
        var is = t.getAttribute('data-vl-bn-tab') === key;
        t.setAttribute('aria-selected', is ? 'true' : 'false');
        t.setAttribute('tabindex', is ? '0' : '-1');
      });
      current = key;

      if (opts.hash) {
        try { window.history.replaceState(null, '', '#' + key); } catch (e) { /* bez istorije */ }
      }

      if (opts.scroll === 'actions') {
        var row = $('[data-vl-bn-actions]', panel);
        scrollToEl(row || panel, 120);
        var cta = $('[data-vl-bn-cta]', panel);
        if (cta && typeof cta.focus === 'function') {
          window.setTimeout(function () { cta.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
        }
      } else if (opts.scroll) {
        scrollToEl(panel);
      }

      queuePass(panel);
      root.dispatchEvent(new CustomEvent('vl-bn:panel', { detail: { key: key } }));
    }

    tabs.forEach(function (tab) {
      on(tab, 'click', function () {
        activate(tab.getAttribute('data-vl-bn-tab'), { scroll: true, hash: true });
      });
      /* strelice među tabovima, kao pravi tablist */
      on(tab, 'keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var i = tabs.indexOf(tab);
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        if (next) { next.focus(); next.click(); }
        e.preventDefault();
      });
    });

    on(window, 'hashchange', function () {
      var key = keyFromUrl();
      if (key && key !== current) activate(key, { scroll: true });
    });

    /* ---- Rapi: slot, izabrana traka, pokloni po količini, cene ---- */

    var BUNDLE = '[class^="rapi-bundle-content"], [class*=" rapi-bundle-content"], .rapi-bundles';

    function barIndex(bar) {
      var input = bar.querySelector('input[type="radio"], input[type="checkbox"]');
      var m = input && /deal-(\d+)-/.exec(input.id || '');
      if (m) return parseInt(m[1], 10);
      var bars = bar.parentNode ? $$('.rapi-bundles__bar', bar.parentNode) : [];
      return bars.indexOf(bar);
    }

    function tierQuantity(panel, bar) {
      var idx = barIndex(bar);
      var bundle = window['rapi_bundle_' + panel.getAttribute('data-product-id')];
      var o = bundle && bundle.offers && bundle.offers[idx];
      if (o && parseInt(o.quantity, 10) > 0) return parseInt(o.quantity, 10);
      /* bez Rapi podataka: standardni redosled paketa u prodavnici */
      return [1, 2, 3, 6][idx] || null;
    }

    function selectedBar(panel, bars) {
      var i;
      for (i = 0; i < bars.length; i++) {
        var input = bars[i].querySelector('input[type="radio"], input[type="checkbox"]');
        if (input && input.checked) { panel.vlBnLastBar = bars[i]; return bars[i]; }
      }
      for (i = 0; i < bars.length; i++) {
        var theirs = bars[i].className.split(SELECTED).join('');
        if (/selected|active|checked/i.test(theirs)) { panel.vlBnLastBar = bars[i]; return bars[i]; }
      }
      if (panel.vlBnLastBar && panel.contains(panel.vlBnLastBar)) return panel.vlBnLastBar;
      panel.vlBnLastBar = bars[0] || null;
      return panel.vlBnLastBar;
    }

    function placeGift(panel, bar) {
      var q = tierQuantity(panel, bar);
      var text = q ? (panel.getAttribute('data-gift-' + q) || '') : '';
      var existing = bar.querySelector('.vl-bn-gift');
      if (!text) {
        if (existing) existing.parentNode.removeChild(existing);
        return;
      }
      if (existing) {
        if (existing.getAttribute('data-q') !== String(q)) {
          existing.setAttribute('data-q', String(q));
          existing.lastChild.textContent = text;
        }
        return;
      }
      var host = bar.querySelector('.rapi-bundles__bar-container') || bar;
      var strip = doc.createElement('span');
      strip.className = 'vl-bn-gift';
      strip.setAttribute('data-q', String(q));
      strip.innerHTML = GIFT_ICON + '<span></span>';
      strip.lastChild.textContent = text;
      host.appendChild(strip);
    }

    function priceNode(bar) {
      return bar.querySelector('.rapi-bundles__bar-price .rapi-money') || bar.querySelector('.rapi-bundles__bar-price');
    }

    /*
      Cena paketa u RSD iz Rapi podataka (comparedPrice − popust), nezavisno od toga šta je
      trenutno ispisano: konverter valuta (BUCKS, kupci iz BiH) prepisuje tekst u KM, pa se
      ispisani tekst ne sme uzimati kao osnova. Isti račun kao u assets/vl-zglobovi.js.
    */
    function rapiBasePrice(panel, bar) {
      var bundle = window['rapi_bundle_' + panel.getAttribute('data-product-id')];
      var o = bundle && bundle.offers && bundle.offers[barIndex(bar)];
      if (!o) return null;
      var full = Number(o.comparedPrice || o.subTotal) || 0;
      var qty = Number(o.quantity) || 1;
      var dv = Number(o.discount_value) || 0;
      var type = o.discount_type || o.discountType;
      var price = full;
      if (type === 'amount') price = full - dv * qty;
      else if (type === 'percentage') price = full * (1 - dv / 100);
      price = Math.round(price);
      return price > 0 ? price : null;
    }

    /* format koji BUCKS čita kao osnovu u RSD (isti kao Rapi: 2,160.00 RSD) */
    function formatRsd(n) {
      var parts = Number(n).toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1] + ' RSD';
    }

    /*
      Novu cenu upisuje VilaMarketMoney.setBaseText (assets/vila-market-money.js, učitan iz
      theme.liquid): postavi RSD osnovu i zatraži od BUCKS-a da je prikaže u valuti kupca.
      Bez toga bi se RSD osnova i KM prikaz naizmenično prepisivali.
    */
    function setMoney(el, text) {
      if (window.VilaMarketMoney && typeof window.VilaMarketMoney.setBaseText === 'function') {
        window.VilaMarketMoney.setBaseText(el, text);
        return;
      }
      if (el.getAttribute('data-vl-bn-set') === text) return;
      el.setAttribute('data-vl-bn-set', text);
      el.textContent = text;
    }

    /* cena na traci pada tek posle potvrde koda */
    function applyOffer(panel, bar) {
      if (!claimed || ended || !offerActive) return;
      var el = priceNode(bar);
      if (!el) return;
      var base = rapiBasePrice(panel, bar);
      if (base === null) {
        /* bez Rapi podataka: ispisani tekst, i to samo dok je u RSD */
        if (typeof el.dataset.vlBnOrig !== 'string') el.dataset.vlBnOrig = el.textContent;
        var orig = el.dataset.vlBnOrig;
        if (!/RSD|Din/i.test(orig)) return;
        var parsed = parsePrice(orig);
        if (!parsed || !(parsed.value > 0)) return;
        base = parsed.value;
      }
      var next = offer.type === 'percent' ? base * (1 - offer.value / 100) : base - offer.value;
      next = Math.round(next);
      if (!(next > 0)) return;
      setMoney(el, formatRsd(next));
    }

    function pass(panel) {
      var slot = $('[data-vl-bn-slot]', panel);
      if (!slot) return;

      var bundle = panel.querySelector(BUNDLE);
      if (bundle && !slot.contains(bundle)) slot.appendChild(bundle);
      var has = !!(bundle && slot.contains(bundle));
      slot.setAttribute('data-state', has ? 'filled' : 'empty');
      setHidden($('[data-vl-bn-native]', panel), has);
      if (!has) return;

      var bars = $$('.rapi-bundles__bar', bundle);
      var sel = selectedBar(panel, bars);
      bars.forEach(function (bar) {
        bar.classList.toggle(SELECTED, bar === sel);
        placeGift(panel, bar);
        applyOffer(panel, bar);
      });
      panel.vlBnSelected = sel;
    }

    /* jedan prolaz po frejmu; dok je pokazivač pritisnut, prolazi čekaju (klik ne sme da "propadne") */
    var pointerDown = false;
    var queued = [];
    var scheduled = false;

    function flush() {
      scheduled = false;
      if (pointerDown) return;
      var list = queued;
      queued = [];
      list.forEach(function (panel) {
        try { pass(panel); } catch (e) { if (window.console) console.error('[vl-bn]', e); }
      });
    }

    function queuePass(panel) {
      if (queued.indexOf(panel) === -1) queued.push(panel);
      if (scheduled) return;
      scheduled = true;
      raf(flush);
    }

    function queueAll() { panels.forEach(queuePass); }

    function releasePointer() {
      window.setTimeout(function () {
        pointerDown = false;
        if (queued.length && !scheduled) { scheduled = true; raf(flush); }
      }, 0);
    }

    on(root, 'pointerdown', function () { pointerDown = true; }, true);
    on(doc, 'pointerup', releasePointer, true);
    on(doc, 'pointercancel', releasePointer, true);

    panels.forEach(function (panel) {
      new MutationObserver(function () { queuePass(panel); }).observe(panel, { childList: true, subtree: true });
      on(panel, 'change', function () { queuePass(panel); });
      on(panel, 'click', function (e) {
        if (e.target.closest && e.target.closest('.rapi-bundles__bar')) queuePass(panel);
      });
    });

    /* ---- dodaj u korpu / kupi odmah ---- */

    $$('form[data-vl-bn-form]', root).forEach(function (form) {
      var panel = form.closest('[data-vl-bn-panel]');
      var errorEl = panel ? $('[data-vl-bn-error]', panel) : null;
      var lastSubmitter = null;

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        setHidden(errorEl, !message);
      }

      on(form, 'click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[type="submit"]') : null;
        if (t) lastSubmitter = t;
      });

      on(form, 'submit', function (e) {
        if (typeof window.fetch !== 'function') return;
        e.preventDefault();
        showError('');

        var submit = e.submitter || lastSubmitter || form.querySelector('[type="submit"]');
        var buyNow = !!(submit && submit.hasAttribute('data-vl-bn-buy-now'));
        lastSubmitter = null;
        if (submit) {
          if (submit.getAttribute('aria-busy') === 'true') return;
          submit.setAttribute('aria-busy', 'true');
        }

        var payload = new FormData(form);
        var bar = panel ? panel.vlBnSelected : null;
        var q = bar ? tierQuantity(panel, bar) : null;
        if (q) payload.set('quantity', String(q));

        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: payload })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) {
              showError(res.body.description || res.body.message || 'Proizvod trenutno nije moguće dodati u korpu.');
              return;
            }
            if (buyNow) {
              /* na vilapure.ba kapija prvo otvara EasySell, inače kasa */
              if (window.vilaCheckout) {
                Promise.resolve(window.vilaCheckout.go('/checkout')).then(function (opened) {
                  /* EasySell forma ostaje na strani: otključaj dugme da kupac može ponovo */
                  if (opened && submit) submit.removeAttribute('aria-busy');
                });
              } else {
                window.location.href = '/checkout';
              }
              return;
            }
            return refreshCartDrawer().then(openCartDrawer);
          })
          .catch(function () { form.submit(); })
          .then(function () { if (submit && !buyNow) submit.removeAttribute('aria-busy'); });
      });
    });

    /* ---- akcija (kod popusta) ---- */

    if (offerActive) {
      var CLAIM_KEY = 'vlBnClaimed:' + offer.code;

      var markClaimed = function () {
        claimed = true;
        root.setAttribute('data-vl-bn-claimed', '');
        $$('[data-vl-bn-claim]', root).forEach(function (btn) { setHidden(btn, true); });
        $$('[data-vl-bn-done]', root).forEach(function (el) { setHidden(el, false); });
        queueAll();
      };

      var showClaimButtons = function () {
        $$('[data-vl-bn-claim]', root).forEach(function (btn) { setHidden(btn, false); });
      };

      var claim = function (viaClick) {
        return fetch(offer.url, { credentials: 'same-origin' })
          .then(function (r) {
            if (!r.ok) throw new Error('discount ' + r.status);
            writeStore('sessionStorage', CLAIM_KEY, '1');
            markClaimed();
            if (typeof window.clarity === 'function') { try { window.clarity('event', 'bnOfferClaimed'); } catch (e) { /* bez Clarity-ja */ } }
          })
          .catch(function () {
            if (viaClick) window.location.href = offer.url;
            else showClaimButtons();
          });
      };

      $$('[data-vl-bn-claim]', root).forEach(function (btn) {
        on(btn, 'click', function (e) {
          e.preventDefault();
          if (btn.getAttribute('aria-busy') === 'true') return;
          btn.setAttribute('aria-busy', 'true');
          claim(true).then(function () { btn.removeAttribute('aria-busy'); });
        });
      });

      if (ended || remaining() === 0) {
        /* istekla akcija: ništa se ne aktivira, CSS sakriva ponudu */
      } else if (readStore('sessionStorage', CLAIM_KEY) === '1') {
        markClaimed();
      } else if (offer.mode === 'auto') {
        claim(false);
      } else {
        showClaimButtons();
      }
    }

    /* ---- sticky traka ---- */

    var sticky = $('[data-vl-bn-sticky]', root);
    if (sticky) {
      var stickyCta = $('[data-vl-bn-sticky-cta]', sticky);
      var stickyShown = false;

      var setSticky = function (show) {
        if (show === stickyShown) return;
        stickyShown = show;
        setHidden(sticky, !show);
        doc.body.style.paddingBottom = show ? sticky.getBoundingClientRect().height + 'px' : '';
      };

      var evaluateSticky = function () {
        if (!mobileQuery || !mobileQuery.matches) { setSticky(false); return; }
        var panel = current ? panelByKey(current) : null;
        var row = panel ? $('[data-vl-bn-actions]', panel) : null;
        if (!row) { setSticky(false); return; }
        var r = row.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight;
        setSticky(!inView && window.pageYOffset > 240);
      };

      var stickyQueued = false;
      var queueSticky = function () {
        if (stickyQueued) return;
        stickyQueued = true;
        raf(function () { stickyQueued = false; evaluateSticky(); });
      };

      on(window, 'scroll', queueSticky, { passive: true });
      on(window, 'resize', queueSticky);
      on(root, 'vl-bn:panel', queueSticky);
      on(stickyCta, 'click', function () { activate(current, { scroll: 'actions' }); });
      startClock();
      queueSticky();
    }

    /* ---- start ---- */

    activate(keyFromUrl() || tabs[0].getAttribute('data-vl-bn-tab'), { scroll: false });
    queueAll();
    startClock();
    on(doc, 'vl-bn:ended', queueAll);
  }

  /* ------------------------------------------------------------ init */

  function initAll(scope) {
    $$('[data-vl-bn-hero]', scope).forEach(initHero);
    $$('[data-vl-bn-paketi]', scope).forEach(initPaketi);
    hideTimersWithoutDeadline(scope);
  }

  if (doc.readyState === 'loading') {
    on(doc, 'DOMContentLoaded', function () { initAll(doc); });
  } else {
    initAll(doc);
  }

  on(doc, 'shopify:section:load', function (e) { initAll(e.target); });
})();
